module.exports = __webpack_public_path__ + "assets/img/sliderItem2.49cac546.png";